export default "__VITE_ASSET__56e4c115__"